var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4254 14.0002C24.4254 13.7132 24.3334 13.4777 24.1495 13.2938C23.9729 13.1098 23.7411 13.0178 23.4541 13.0178L8.91672 13.0178L5.62733 13.1282L5.84809 13.7574L10.1861 9.79465L12.6587 7.27794C12.747 7.18963 12.8132 7.08661 12.8574 6.96886C12.9015 6.84376 12.9236 6.71499 12.9236 6.58253C12.9236 6.31025 12.8316 6.08581 12.6476 5.90919C12.4637 5.72523 12.2355 5.63324 11.9633 5.63324C11.6984 5.63324 11.4592 5.73258 11.2458 5.93127L3.90537 13.2607C3.79498 13.3637 3.71404 13.4777 3.66252 13.6028C3.60365 13.7279 3.57422 13.8604 3.57422 14.0002C3.57422 14.1327 3.60365 14.2615 3.66252 14.3866C3.71404 14.5117 3.79498 14.6294 3.90537 14.7398L11.2458 22.0581C11.4592 22.2642 11.6984 22.3672 11.9633 22.3672C12.2355 22.3672 12.4637 22.2789 12.6476 22.1023C12.8316 21.9183 12.9236 21.6902 12.9236 21.4179C12.9236 21.2854 12.9015 21.1603 12.8574 21.0426C12.8132 20.9175 12.747 20.8108 12.6587 20.7225L10.1861 18.2058L5.84809 14.2541L5.62733 14.8722L8.91672 14.9826H23.4541C23.7411 14.9826 23.9729 14.8906 24.1495 14.7067C24.3334 14.5227 24.4254 14.2872 24.4254 14.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowNew);
export default __webpack_public_path__ + "static/media/backArrowNew.11cd8596aa9892ca82ece5ecf7c80a82.svg";
export { ForwardRef as ReactComponent };